import { useId } from 'react'

/**
 * `useId` con un identificatore usabile anche nei selettori CSS.
 *
 * React 18 genera id nella forma `:r3:`. I due punti sono validi in HTML, ma
 * rendono l'id inutilizzabile in un selettore: `document.querySelector('#:r3:')`
 * solleva `SyntaxError`. Se ne accorgono sia il codice che deve raggiungere
 * l'elemento sia i validatori di accessibilità, che segnalano il riferimento
 * come non valido.
 *
 * Restituisce lo stesso identificatore senza i due punti. L'unicità resta
 * garantita da React: è la parte interna a essere univoca, non i delimitatori.
 */
export default function useIdStabile(): string {
  return useId().replace(/:/g, '')
}
